var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import ConfirmPopup from '../../common/confirm';
import WorkflowStepsList from './workflow-step-list';
import WorkflowStepEditor from './workflow-step-editor';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormControlLabel, IconButton } from '@mui/material';
var WorkflowEditor = /** @class */ (function (_super) {
    __extends(WorkflowEditor, _super);
    function WorkflowEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedStepIndex: 0,
            deleteStepIndex: -1
        };
        return _this;
    }
    Object.defineProperty(WorkflowEditor.prototype, "onEnabledOfflineWorkflowChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var currentCaseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (currentCaseType)
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(__assign(__assign({}, currentCaseType), { enableOfflineWorkflow: e.target.checked }));
        }
    });
    Object.defineProperty(WorkflowEditor.prototype, "onStepEditClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (index) {
            this.setState(__assign(__assign({}, this.state), { selectedStepIndex: index }));
        }
    });
    Object.defineProperty(WorkflowEditor.prototype, "onStepAddClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b;
            var currentCaseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            var oldSteps = currentCaseType === null || currentCaseType === void 0 ? void 0 : currentCaseType.workflowSteps;
            if (!oldSteps)
                return;
            var newStepIndex = oldSteps.length;
            var newSteps = __spreadArray([], oldSteps, true);
            newSteps.push({
                id: '',
                caseTypeId: currentCaseType.id,
                title: "Step " + (newStepIndex + 1),
                tag: "",
                description: "",
                order: newStepIndex,
                isMultiAttachment: false
            });
            (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(__assign(__assign({}, currentCaseType), { workflowSteps: newSteps }));
            this.setState(__assign(__assign({}, this.state), { selectedStepIndex: newStepIndex }));
        }
    });
    Object.defineProperty(WorkflowEditor.prototype, "onStepDeleteClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (index) {
            this.setState(__assign(__assign({}, this.state), { deleteStepIndex: index }));
        }
    });
    Object.defineProperty(WorkflowEditor.prototype, "onStepChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (step, index) {
            var _a, _b;
            var currentCaseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            var oldSteps = currentCaseType === null || currentCaseType === void 0 ? void 0 : currentCaseType.workflowSteps;
            if (!oldSteps)
                return;
            var newSteps = __spreadArray([], oldSteps, true);
            newSteps[index] = step;
            (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(__assign(__assign({}, currentCaseType), { workflowSteps: newSteps }));
        }
    });
    Object.defineProperty(WorkflowEditor.prototype, "onStepsReordered", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (newSteps, index) {
            var _a, _b;
            var currentCaseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (!currentCaseType)
                return;
            (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(__assign(__assign({}, currentCaseType), { workflowSteps: newSteps }));
            this.setState(__assign(__assign({}, this.state), { selectedStepIndex: index }));
        }
    });
    Object.defineProperty(WorkflowEditor.prototype, "onConfirmPopupClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isOK) {
            if (isOK)
                this.deleteStep(this.state.deleteStepIndex);
            this.setState(__assign(__assign({}, this.state), { deleteStepIndex: -1 }));
        }
    });
    Object.defineProperty(WorkflowEditor.prototype, "deleteStep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (index) {
            var _a, _b;
            var currentCaseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            var oldSteps = currentCaseType === null || currentCaseType === void 0 ? void 0 : currentCaseType.workflowSteps;
            if (!oldSteps)
                return;
            var newSteps = __spreadArray([], oldSteps, true);
            newSteps.splice(index, 1);
            (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(__assign(__assign({}, currentCaseType), { workflowSteps: newSteps }));
            var newSelectedStepIndex = index - 1;
            if (newSelectedStepIndex < 0)
                newSelectedStepIndex = 0;
            this.setState(__assign(__assign({}, this.state), { selectedStepIndex: newSelectedStepIndex }));
        }
    });
    Object.defineProperty(WorkflowEditor.prototype, "renderList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (enable) {
            var _this = this;
            var _a, _b;
            var steps = (_b = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType) === null || _b === void 0 ? void 0 : _b.workflowSteps;
            if (!steps)
                return null;
            return (_jsxs("div", __assign({ className: "flex flex-col", style: { flex: "0 0 400px" } }, { children: [_jsxs("div", __assign({ className: "flex-row justify-space-between", style: { minHeight: "50px" } }, { children: [_jsx(FormControlLabel, { label: "Enable Guided Offline Assessment", sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", checked: enable, onChange: function (e) { return _this.onEnabledOfflineWorkflowChange(e); } }, void 0) }, void 0), enable
                                ? _jsx(IconButton, __assign({ size: "large", onClick: function () { return _this.onStepAddClick(); } }, { children: _jsx(AddCircleIcon, {}, void 0) }), void 0)
                                : null] }), void 0), _jsx(WorkflowStepsList, { disabled: !enable, steps: steps, selectedStepIndex: this.state.selectedStepIndex, onStepEditClick: function (index) { return _this.onStepEditClick(index); }, onStepDeleteClick: function (index) { return _this.onStepDeleteClick(index); }, onStepsReordered: function (s, i) { return _this.onStepsReordered(s, i); } }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(WorkflowEditor.prototype, "renderEditor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (enable) {
            var _this = this;
            var _a, _b, _c;
            var steps = (_b = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType) === null || _b === void 0 ? void 0 : _b.workflowSteps;
            if (!steps || this.state.selectedStepIndex >= steps.length)
                return null;
            var step = steps[this.state.selectedStepIndex];
            return (_jsx(WorkflowStepEditor, { disabled: !enable, step: step, index: this.state.selectedStepIndex, caseType: (_c = this.props.caseTypesStore) === null || _c === void 0 ? void 0 : _c.currentCaseType, onStepChange: function (s, i) { return _this.onStepChange(s, i); } }, void 0));
        }
    });
    Object.defineProperty(WorkflowEditor.prototype, "renderConfirmPopup", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsx(ConfirmPopup, { content: "Do you wish to delete this step?", isOpen: this.state.deleteStepIndex >= 0, onClose: function (isOK) { return _this.onConfirmPopupClose(isOK); } }, void 0));
        }
    });
    Object.defineProperty(WorkflowEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b, _c;
            var enable = (_c = (_b = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType) === null || _b === void 0 ? void 0 : _b.enableOfflineWorkflow) !== null && _c !== void 0 ? _c : false;
            return (_jsxs("div", __assign({ className: "flex flex-row overflow-hidden" }, { children: [this.renderList(enable), this.renderEditor(enable), this.renderConfirmPopup()] }), void 0));
        }
    });
    WorkflowEditor = __decorate([
        inject('caseTypesStore'),
        inject('languageStore'),
        observer
    ], WorkflowEditor);
    return WorkflowEditor;
}(React.Component));
export default WorkflowEditor;
